<template>
  <el-dialog
    title="设置黑名单"
    :visible.sync="visible"
    width="50%"
    :close-on-click-modal="true"
    @close="handleClose"
  >
    <div class="search-section">
      <div class="flex align-items marginBottom10">
        <span class="span marginRight10 width100 textAlignRight">字典项名称 :</span>
        <div class="width250">
          <el-input
            v-model="searchForm.itemName"
            placeholder="请输入字典项名称"
            clearable
            maxlength="50"
          ></el-input>
        </div>
        <span class="span marginRight10 marginLeft20 width100 textAlignRight">字典项编码 :</span>
        <div class="width250">
          <el-input
            v-model="searchForm.itemCode"
            placeholder="请输入字典项编码"
            clearable
            maxlength="50"
          ></el-input>
        </div>
        <el-button
          size="medium"
          type="primary"
          @click="handleSearch"
          class="marginLeft10"
        >搜索</el-button>
        <el-button
          size="medium"
          type="info"
          @click="handleReset"
          class="marginLeft10"
        >重置</el-button>
      </div>
    </div>
    <div v-loading="loading" class="blacklist-content">
      <el-table
        ref="blacklistTable"
        :data="filteredBlacklistData"
        border
        size="small"
        max-height="400"
        class="blacklist-table"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
          :selectable="() => true"
        ></el-table-column>
        <el-table-column
          label="字典项名称"
          prop="itemName"
          align="center"
        ></el-table-column>
        <el-table-column
          label="字典项编码"
          prop="itemCode"
          align="center"
        ></el-table-column>
        <el-table-column
          label="字典项值"
          prop="itemValue"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button 
        type="primary" 
        @click="handleSubmit"
        :disabled="selectedCount === 0 || submitting"
        :loading="submitting"
      >确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { waveformDictCode } from "@/api/waveform/manage";
import { loadSetGatewayBlackList } from "@/api/waveform/gateway";

export default {
  name: "BlacklistDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedGateways: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      submitting: false,
      blacklistData: [],
      selectedCount: 0,
      searchForm: {
        itemName: "",
        itemCode: "",
      },
    };
  },
  computed: {
    filteredBlacklistData() {
      return this.blacklistData.filter((item) => {
        const nameMatch = item.itemName
          .toLowerCase()
          .includes(this.searchForm.itemName.toLowerCase());
        const codeMatch = item.itemCode
          .toLowerCase()
          .includes(this.searchForm.itemCode.toLowerCase());
        return nameMatch && codeMatch;
      });
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.fetchBlacklistData();
      }
    },
  },
  methods: {
    fetchBlacklistData() {
      this.loading = true;
      waveformDictCode("cnnModeRecognitionType")
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            this.blacklistData = res.data || [];
          } else {
            this.$message.error("获取黑名单数据失败");
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("获取黑名单数据失败:", error);
          this.$message.error("获取黑名单数据失败，请稍后重试");
        });
    },
    handleSubmit() {
      const selectedBlacklist = this.$refs.blacklistTable.selection;
      if (selectedBlacklist.length === 0) {
        this.$message.warning("请先选择黑名单项");
        return;
      }

      const requestData = {
        gatewayIdList: this.selectedGateways.map((row) => row.id),
        dictItemIdList: selectedBlacklist.map((row) => row.id),
      };

      console.log("提交数据:", requestData);

      this.submitting = true;
      loadSetGatewayBlackList(requestData)
        .then((res) => {
          this.submitting = false;
          if (res.code === 200) {
            this.$message.success("设置黑名单成功");
            this.handleClose();
            this.$emit("success");
          } else {
            this.$message.error(res.msg || "设置黑名单失败");
          }
        })
        .catch((error) => {
          this.submitting = false;
          console.error("设置黑名单失败:", error);
          this.$message.error("设置黑名单失败，请稍后重试");
        });
    },
    handleCancel() {
      this.handleClose();
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.blacklistTable.clearSelection();
      this.selectedCount = 0;
      this.handleReset();
      this.$emit("refresh");
    },
    handleSearch() {
      // 搜索逻辑由计算属性处理
    },
    handleReset() {
      this.searchForm.itemName = "";
      this.searchForm.itemCode = "";
    },
    handleSelectionChange(selection) {
      this.selectedCount = selection.length;
    },
  },
};
</script>

<style scoped>
.blacklist-content {
  padding-top: 10px;
  max-height: 400px;
  overflow-y: auto;
}
.el-table >>> .el-table__header-wrapper .el-table__header th {
  background-color: #fafafa;
}
</style>
